import { computed } from '@ember/object';
import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

export default ShModel.extend({
    comment: attr('string'),
    createdAt: attr('date'),
    score: attr('number'),

    project: belongsTo('project', { async: false }),
    projectdigest: belongsTo('projectdigest', { async: false }),
    reviewer: belongsTo('user', { async: false }),

    scoreIcons: computed('score', function () {
        let score = this.get('score');
        let icons = [];
        for (let i=1; i<= 5; i++) {
            let icon = score >= i ? 'star' : 'star_border';
            icons.pushObject(icon);
        }
        return icons;
    })
});
